export var TelemetryType = {
  log: 'log',
  configuration: 'configuration'
};